import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 4,
          px: 3,
        }}
      >
        {/* 404 Icon */}
        <Box
          sx={{
            p: 4,
            borderRadius: '50%',
            bgcolor: 'primary.light',
            color: 'primary.contrastText',
            mb: 2,
          }}
        >
          <SearchOffIcon sx={{ fontSize: 80 }} />
        </Box>

        {/* Error Code */}
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '4rem', md: '6rem' },
            fontWeight: 'bold',
            color: 'primary.main',
            lineHeight: 1,
          }}
        >
          404
        </Typography>

        {/* Error Message */}
        <Box sx={{ maxWidth: 500 }}>
          <Typography variant="h4" gutterBottom fontWeight="bold">
            {t('errors.notFound.title', 'Sayfa Bulunamadı')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {t('errors.notFound.message', 'Aradığınız sayfa mevcut değil veya taşınmış olabilir. URL\'yi kontrol edin veya ana sayfaya dönün.')}
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{ minWidth: 150 }}
          >
            {t('errors.notFound.goHome', 'Ana Sayfaya Dön')}
          </Button>
          
          <Button
            variant="outlined"
            size="large"
            startIcon={<ArrowBackIcon />}
            onClick={handleGoBack}
            sx={{ minWidth: 150 }}
          >
            {t('errors.notFound.goBack', 'Geri Dön')}
          </Button>
        </Box>

        {/* Additional Help Text */}
        <Box sx={{ mt: 4, p: 3, bgcolor: 'grey.50', borderRadius: 2, maxWidth: 600 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>{t('errors.notFound.suggestions', 'Öneriler:')}</strong>
            <br />
            • {t('errors.notFound.checkUrl', 'URL adresini kontrol edin')}
            <br />
            • {t('errors.notFound.useNavigation', 'Sol menüyü kullanarak sayfalar arasında gezinin')}
            <br />
            • {t('errors.notFound.contactAdmin', 'Sorun devam ederse sistem yöneticinizle iletişime geçin')}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFoundPage; 